export var SENTRY_RELEASE = "49c0586d67024d3b2a325119749f916d5c2a3b95";
